import { render, staticRenderFns } from "./NeedApprovalList.vue?vue&type=template&id=7eaddeb2&scoped=true&"
import script from "./NeedApprovalList.vue?vue&type=script&lang=ts&"
export * from "./NeedApprovalList.vue?vue&type=script&lang=ts&"
import style0 from "./NeedApprovalList.vue?vue&type=style&index=0&id=7eaddeb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eaddeb2",
  null
  
)

export default component.exports